import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["indicator", "mobileIndicator"]
  static values = { draft: Boolean }

  connect() {
    if (this.draftValue) {
      this.element.addEventListener("incident-form:autosave", this.handleAutosave.bind(this))
    }
  }

  disconnect() {
    if (this.draftValue) {
      this.element.removeEventListener("incident-form:autosave", this.handleAutosave.bind(this))
    }
  }

  handleAutosave(event) {
    const { status, timestamp } = event.detail

    let text = ""
    let className = "text-sm text-slate-500"

    switch (status) {
      case "saving":
        text = "Saving..."
        className = "text-sm text-slate-500"
        break
      case "saved":
        const time = timestamp ? new Date(timestamp).toLocaleTimeString() : new Date().toLocaleTimeString()
        text = `Draft saved at ${time}`
        className = "text-sm text-green-600"
        break
      case "error":
        text = "Failed to save draft"
        className = "text-sm text-red-600"
        break
    }

    if (this.hasIndicatorTarget) {
      this.indicatorTarget.textContent = text
      this.indicatorTarget.className = className + " hidden lg:block"
    }

    if (this.hasMobileIndicatorTarget) {
      this.mobileIndicatorTarget.textContent = text
      this.mobileIndicatorTarget.className = className + " mt-1 lg:hidden"
    }
  }
}
